import styled from "styled-components";

import { AppBar, Container, Toolbar, Typography } from "@mui/material";
import Colors from "@src/constants/Colors";
import { ZIndex } from "@src/constants";

export const StyledContainer = styled(Container)`
  padding: 0 !important;
`;

export const DesktopLogoWrapper = styled.div`
  width: 24%;
`;

export const HeaderButtonWrapper = styled.div`
  min-width: 17%;
`;

export const StyledTypography = styled(Typography)<{
  isDesktop?: boolean;
}>`
  flex-grow: 1;
  font-family: "RingSide Regular-Bold" !important;
  font-weight: 400 !important;
  font-size: ${(props) => (props.isDesktop ? "28" : "18")}px !important;
  line-height: ${(props) => (props.isDesktop ? "36" : "24")}px !important;
  text-align: ${(props) => (props.isDesktop ? "" : "center")};
  padding-right: 54px;
  color: ${Colors.white} !important;
`;

export const StyledAppBar = styled(AppBar)`
  box-shadow: none !important;
  position: sticky !important;
  z-index: ${ZIndex.LEVEL_2} !important;
  top: 0;
  background-color: ${Colors.secondary}!important;
`;

export const StyledToolbar = styled(Toolbar)<{
  isDesktop?: boolean;
}>`
  display: flex !important;
  gap: ${(props) => (props.isDesktop ? "16" : "14")}px !important;
  min-height: ${(props) => (props.isDesktop ? "80" : "44")}px !important;
`;
